import { throwError as observableThrowError, Observable } from 'rxjs';
import { Injectable } from '@angular/core';

import { isNullOrUndefined } from '../../util/is-null-or-undefined.util';

import { AppSettingsService } from '../../core/configuracao/services/app-settings.service';
import { ExecutorOperacaoCharonService } from '../../core/charon/services/executor-operacao-charon-service';
import { MensagensService } from '../../constantes/mensagens.service';
import { SessaoService } from '../../core/charon/services/sessao.service';

import { ConfiguracaoRequisicaoOperacao } from '../../core/models/configuracao-requisicao-operacao.model';

import { ContaPermitida } from '../models/contaPermitida.model';

/**
 * Serviço de negócio para gerenciamento de permissões
 */
@Injectable()
export class ContaService {
  constructor(
    private executorOpServico: ExecutorOperacaoCharonService,
    private servicoConfiguracao: AppSettingsService,
    private sessaoService: SessaoService
  ) {}

  /**
   * Realiza a busca de contas permitidas de um operador
   * @returns Observable de Array de modelo Conta
   * @throws TypeError para ebusiness_id inválido
   */
  obterContasPermitidas(): Observable<Array<ContaPermitida>> {
    const ebusiness_id = this.sessaoService.obterEbusiness();
    if (!isNullOrUndefined(ebusiness_id) && ebusiness_id.trim() !== '') {
      const configOp = new ConfiguracaoRequisicaoOperacao();
      configOp.metodo = 'GET';
      configOp.nomeOperacao =
        this.servicoConfiguracao.environment.charon.ops.op_permissoes_contas_get;
      configOp.adicionarParametroQuery('ebusiness_id', ebusiness_id);
      return this.executorOpServico.chamarOperacao<Array<ContaPermitida>>(
        configOp
      );
    } else {
      return observableThrowError(
        new TypeError(
          MensagensService.mensagens.operadoresPorContas.mensagensErro.identificadorOperadorNaoPreenchido
        )
      );
    }
  }

  obterContasPermitidasOperador(
    ebusiness_id: string
  ): Observable<Array<ContaPermitida>> {
    if (!isNullOrUndefined(ebusiness_id) && ebusiness_id.trim() !== '') {
      const configOp = new ConfiguracaoRequisicaoOperacao();
      configOp.metodo = 'GET';
      configOp.nomeOperacao =
        this.servicoConfiguracao.environment.charon.ops.op_permissoes_contas_get;
      configOp.adicionarParametroQuery('ebusiness_id', ebusiness_id);
      return this.executorOpServico.chamarOperacao<Array<ContaPermitida>>(
        configOp
      );
    } else {
      return observableThrowError(
        new TypeError(
          MensagensService.mensagens.operadoresPorContas.mensagensErro.identificadorOperadorNaoPreenchido
        )
      );
    }
  }
}
